import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import { AiMessageFeedbackReasonEnum } from 'graphql-common';
import Modal from '@lib/components/Modal/Modal';
import Form from '@lib/components/ReactHookForm/FormContainer';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import { Values } from '@lib/interfaces/form';
import getFeedbackFields, {
  REASON_FIELD,
  COMMENT_FIELD,
} from './utils/getFeedbackFields';

type ActionsProps = {
  loading?: boolean;
  onCancel: () => void;
};

function FeedbackActions({ loading, onCancel }: ActionsProps) {
  const { t } = useTranslation();
  return (
    <ActionsRow
      actions={[
        <Button
          key="cancel"
          buttonType={ButtonTypes.secondaryOutlined}
          buttonText={t('cancel')}
          leftIcon="close"
          onClick={onCancel}
          fullWidth
          disabled={loading}
        />,
        <Button
          key="submit"
          type="submit"
          buttonType={ButtonTypes.primaryFilled}
          buttonText={t('confirm')}
          leftIcon="check"
          fullWidth
          disabled={loading}
        />,
      ]}
    />
  );
}

type Props = {
  isOpen: boolean;
  // Re-keys the form so it re-initialises (clearing prior selection) per open.
  formKey: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (reason: AiMessageFeedbackReasonEnum, comment: string) => void;
};

function AiDislikeFeedbackModal(props: Props) {
  const { isOpen, formKey, loading, onClose, onSubmit } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} caption={t('ai-feedback-title')} onClose={onClose}>
      <Form
        key={formKey}
        defaultValues={{ [REASON_FIELD]: null, [COMMENT_FIELD]: '' }}
        fields={getFeedbackFields(t)}
        onSubmit={(values: Values) =>
          onSubmit(
            _get(values, [
              REASON_FIELD,
              'value',
            ]) as AiMessageFeedbackReasonEnum,
            String(_get(values, COMMENT_FIELD, '')).trim(),
          )
        }
        actionsComponent={FeedbackActions}
        actionsComponentProps={{ loading, onCancel: onClose }}
        loading={loading}
      />
    </Modal>
  );
}

export default AiDislikeFeedbackModal;
